import { render, staticRenderFns } from "./fieldDetail.vue?vue&type=template&id=4cb1a660&scoped=true&"
import script from "./fieldDetail.vue?vue&type=script&lang=js&"
export * from "./fieldDetail.vue?vue&type=script&lang=js&"
import style0 from "./fieldDetail.vue?vue&type=style&index=0&id=4cb1a660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb1a660",
  null
  
)

export default component.exports